export default function haveCompo(resourceType) {
    return [0, 1, 8, 10, 13, 12, 14, 15].includes(resourceType)
}
